new Glide('.glide', {
	type: 'carousel',
	perView: 4,
	breakpoints: {
      1200: {
			perView: 4
		},
		800: {
			perView: 2
		},
        500: {
			perView: 1,
            peek: {
                    before: 0,
                    after: 50
                  }
		}
	}
}).mount();



new Glide('.glide_second', {
	type: 'carousel',
	perView: 5,
	breakpoints: {
      1200: {
			perView: 4
		},
		800: {
			perView: 2
		},
        500: {
			perView: 1,
            peek: {
                    before: 0,
                    after: 100
                  }
		}
	}
}).mount();


new Glide('.glide_thid', {
	type: 'carousel',
	perView: 5,
	breakpoints: {
      1200: {
			perView: 4
		},
		800: {
			perView: 2
		},
        500: {
			perView: 1,
            peek: {
                    before: 0,
                    after: 100
                  }
		}
	}
}).mount();


 /*
 *  Geo Store Locator Pop Up
 *
 *  Version:
 *    1.0.0 - 2020/07/23
 */

function StoreLocatorPopup(container) {
  var thisClass = this
  this.container = container;
  this.delay = parseInt(container.attr('data-popup-delay'));

  // Classes
  // this.classVisible = 'is-visible';

  this.closePopup = this.closePopup.bind(this);

  // Selectors
  this.locationCountryName = this.container.find('[data-popup-location-country-name]');
  this.locationCountryCode = this.container.find('[data-popup-location-country-code]');
  this.currentCountryCode = this.container.find('[data-popup-current-country-code]');
  this.locationStoreUrl = this.container.find('[data-location-store-url]');

  
  var ATTR_TITLE = 'data-title'
  var ATTR_SUB_TITLE = 'data-sub-title'
  var ATTR_GO_BTN = 'data-go-button'
  var ATTR_STAY_BTN = 'data-stay-button'

  var s = selectorFromAttribute = function(attribute){return '['+attribute+']'}

  //Event listeners
  this.container.on('click', s(ATTR_STAY_BTN), function(e){thisClass.closePopup(e)})
  this.container.on('click', s(ATTR_GO_BTN), function(e){thisClass.navigateToClientStore(e)})

  // Geo Specific
  this.CACHE_GEO_DATA;
  this.IS_FETCHING = false;
  this.COOKIE_GEO_CACHE = 'GeoDataCache';
  this.geoPopupCookieName = 'geolocation_popup';
  this.GEO_LISTENERS = [];
  this.popupCountry = container.attr('data-popup-country');

  
  this.textTemplates = {
    title: $(s(ATTR_TITLE)).attr(ATTR_TITLE),
    subTitle: $(s(ATTR_SUB_TITLE)).attr(ATTR_SUB_TITLE),
    gotBtn: $(s(ATTR_GO_BTN)).attr(ATTR_GO_BTN),
    stayBtn: $(s(ATTR_STAY_BTN)).attr(ATTR_STAY_BTN)
  }

  this.decideToShowRegionPopup = function(callbackDecideToShowRegionPopup){
    this.fetchGeo(function(geoData){
      var clientsRegion = JSON.parse($.cookie(thisClass.COOKIE_GEO_CACHE));
      
      var otherStores =JSON.parse( window.otherStores)
      var thisStoresCountryCodes = window.thisStoresCountryCodes
      var clientsStore = getClientsStore()
  
  
      if(dontShowPopupIfAnyAreTrue())
        callbackDecideToShowRegionPopup(false)
      else {
        setTextValues()
        callbackDecideToShowRegionPopup(true)
      }
      
      
  
  
      /* Utility Functions */
  
      function dontShowPopupIfAnyAreTrue(){
        var val = (
          hidePopupCookieIsSet() ||
          clientsCountryMatchesThisStore() ||
          onAnInvalidPage() ||
          templateStringsArentSet() ||
          !clientsStore
        )
        return val
      }
  
      function getClientsStore(){
        if(!otherStores) return

        var foundClientStore
        
        for(var i = 0; i < otherStores.length; i++){
          var store = otherStores[i]
          var storeHasCountryCode = false
          
          for(var k = 0; k < store.countryCodes.length; k++){
            var code = store.countryCodes[k]
            if(code == clientsRegion.country_code){
              storeHasCountryCode = true
              break
            }
          }

          if(store.countryCode == clientsRegion.country_code || storeHasCountryCode){
            foundClientStore = store
            break
          }

        }
        
        return foundClientStore
      }
  
      function templateStringsArentSet(){
        for(var key in thisClass.textTemplates){
          if(!thisClass.textTemplates[key]){
            return true
          }
        }
      }
  
      function clientsCountryMatchesThisStore(){
        if(!clientsRegion || !thisStoresCountryCodes) return
        var lowerClientCountry = clientsRegion.country_code.toLowerCase()
        var lowerStoreCounties = thisStoresCountryCodes.toLowerCase()
        
        var searchIndex = lowerStoreCounties.search(lowerClientCountry)

        return searchIndex >= 0
      }

      function hidePopupCookieIsSet(){
        return $.cookie(thisClass.geoPopupCookieName)
      }
  
      function onAnInvalidPage(){
        return (
          window.location.href.indexOf('/challenge') > 0 ||
          window.location.href.indexOf('customer_posted=true') > 0
        )
      }
  
      function setTextValues(){
  
        var titleTxt = replacePlaceholdersWithValues(thisClass.textTemplates.title)
        var subTitleTxt = replacePlaceholdersWithValues(thisClass.textTemplates.subTitle)
        var goBtnTxt = replacePlaceholdersWithValues(thisClass.textTemplates.gotBtn)
        var stayBtnTxt = replacePlaceholdersWithValues(thisClass.textTemplates.stayBtn)
  
  
        $(s(ATTR_TITLE)).text(titleTxt)
        $(s(ATTR_SUB_TITLE)).text(subTitleTxt)
        $(s(ATTR_GO_BTN)).text(goBtnTxt)
        $(s(ATTR_STAY_BTN)).text(stayBtnTxt)
        $(s(ATTR_GO_BTN)).attr('href', clientsStore.urlptp)
  
      }
  
      function replacePlaceholdersWithValues(templateString){
        // placeholders
        var CLIENT_STORES_COUNTRY_CODE_PLACEHOLDER = '#client-stores-country-code#'
        var CLIENT_STORES_COUNTRY_PLACEHOLDER = '#client-stores-country#'
        var CLIENTS_COUNTRY_PLACEHOLDER = '#clients-country#'
        var CLIENTS_COUNTRY_CODE_PLACEHOLDER = '#clients-country-code#'
  
        return templateString
        .replace(CLIENTS_COUNTRY_PLACEHOLDER, 
          clientsRegion.country_name
        )
        .replace(CLIENTS_COUNTRY_CODE_PLACEHOLDER, 
          clientsRegion.country_code
        )
  
        .replace(CLIENT_STORES_COUNTRY_PLACEHOLDER, clientsStore.title
        )
        .replace(CLIENT_STORES_COUNTRY_CODE_PLACEHOLDER, clientsStore.countryCode)
      }
    })
    


  }
  

  
  this.navigateToClientStore = function(){
    this.setHideRegionPopupCookie()
  }

  
  this.setHideRegionPopupCookie = function(){
    $.cookie(this.geoPopupCookieName, true, { expires: 7 });
  }

  
  this.decideToShowRegionPopup(function(showPopup){

    if(showPopup){
      thisClass.openPopup()
    }
  })


}

StoreLocatorPopup.prototype = {
  fetchGeo: function(callback) {
    // Have we already fetched?
    if(this.CACHE_GEO_DATA) return callback(this.CACHE_GEO_DATA);
    this.GEO_LISTENERS.push(callback);

    // Are we already fetching?
    if(this.IS_FETCHING) return;

    // Check cookie
    try {
      this.CACHE_GEO_DATA = $.cookie(this.COOKIE_GEO_CACHE);
      if(typeof this.CACHE_GEO_DATA === "string") this.CACHE_GEO_DATA = JSON.parse(this.CACHE_GEO_DATA);
    } catch(e) {
      console.error('Failed to parse GeoData, not a huge issue', e);
      this.CACHE_GEO_DATA = null;
    }

    if(this.CACHE_GEO_DATA) return callback(this.CACHE_GEO_DATA);

    //Fetch from Third Party
    this.IS_FETCHING = true;
    var cThis = this;
    $.ajax({
      url: 'https://ipapi.co/json/',
      method: "GET",
      dataType: 'json',
      success: function(data) {
        console.log(data);
        // Trigger our listeners and cache
        cThis.CACHE_GEO_DATA = data;
        cThis.IS_FETCHING = false;
        try {
          $.cookie(cThis.COOKIE_GEO_CACHE, JSON.stringify(data), { expires: 1 });
        } catch(e) {
          console.error('Failed to cache geo data, not a major issue', e);
        }
        // this.GEO_LISTENERS.forEach(gl => gl(data));
        for(var i = 0; i < cThis.GEO_LISTENERS.length; i++) {
          var gl = cThis.GEO_LISTENERS[i];
          gl(data);
        }
        $(document).trigger('onGeo', data);
      },

      error: function(e){
        //Err.
        console.error(`Failed to fetch geo data`);
        console.error(e);
      }
    });
  },

  openPopup: function() {
    // Set window popup property to true to prevent other popups from running

    var delay = this.delay && parseInt(this.delay)* 1000 || 3000;

    setTimeout(function(thisClass){
      $('html, body').addClass('showing-popup');
      thisClass.container.removeClass('is-hidden');
    }, delay, this);
  },

  closePopup: function() {
    this.setHideRegionPopupCookie()
    $('html, body').removeClass('showing-popup');
    this.container.fadeOut();
  }
}

$(document).ready(function() {
  $('[data-store-locator-popup]').each(function() {
    var self = $(this);
    window.productBundle = new StoreLocatorPopup(self);
  });
});

 /*
 * -----------------------------------------------------------------------------
 *  End of Geo Store Locator Pop Up
 * -----------------------------------------------------------------------------
 */